export default __webpack_public_path__ + "static/media/SIAKNG-SLCM.57bdb77f.svg";